import { render, staticRenderFns } from "./MyTransactionsTab.vue?vue&type=template&id=218cee9a"
import script from "./MyTransactionsTab.vue?vue&type=script&lang=js"
export * from "./MyTransactionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports